import React from 'react';
import { useGameImageUrls } from '@core/js/hooks/games';
import { Image } from '@core/js/components/common/Image';
import { AccessibilityElement } from '@core/js/components/common/AccessibilityElement';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';
import { useOpenGame } from '@theme/js/components/main/TopWinners/hooks/useOpenGame';

import style from '@core/js/components/main/TopWinners/components/Carousel/components/CarouselItem/CarouselItem.scss';

export const CarouselItem = (props) => {
    const { gameCode: code, player, winAmount, gameName, setWinnerItemRef, className } = props;
    const translate = useComponentTranslations();
    const imageUrls = useGameImageUrls({ code });

    const openGame = useOpenGame(code); /* Lugano changes */

    return (
        <AccessibilityElement
            onClick={openGame}
            elementRef={setWinnerItemRef}
            className={`${style.carouselContainer} ${className}`}
            aria-label={`${translate('playtech.mobile.system.game.aria-label')} ${gameName}`}
        >
            <div className={style.imageContainer}>
                <Image
                    alt={gameName}
                    src={imageUrls}
                    className={style.image}
                />
            </div>
            <div className={style.columnInfo}>
                <span className={`${style.justWon} ${style.ellipsis}`}>{`${player} ${translate('justWon')}`}</span>
                <span className={style.winAmount}>{winAmount}</span>
                <span className={style.ellipsis}>{`${translate('inGame')} ${gameName}`}</span>
            </div>
        </AccessibilityElement>
    );
};
